{
  "name": "@shopliftr/partner",
  "description": "MGD/Shopliftr Partner Portal",
  "version": "19.21.0"
}
